export default `
  query getCurrentUser {
    getCurrentUser {
      id
      email
      firstname
      lastname
      company
      phoneNumber
      job
      hasMcpApiKey
      picture {
        name
        url
        file {
          region
          bucket
          key
        }
        mimeType
      }
      githubAccounts {
        login
        avatar
      }
    }
  }
`
